import React, { useEffect, useState } from 'react';
import '../../scss/components/ProfilePage/SocialLinks.scss';

const SocialLinks = ({ links }) => {
    const [visibleItems, setVisibleItems] = useState([]);

    // Функция для открытия внешней ссылки
    const openExternalLink = (url) => {
        if (window.Telegram && window.Telegram.WebApp) {
            window.Telegram.WebApp.openLink(url);
        } else {
            window.open(url, '_blank');
        }
    };

    // Эффект для постепенного появления иконок
    useEffect(() => {
        // Очистим массив при монтировании
        setVisibleItems([]);

        // Постепенно добавляем каждую иконку с задержкой
        links.forEach((_, index) => {
            setTimeout(() => {
                setVisibleItems(prev => [...prev, index]);
            }, 200 + index * 300); // Задержка для каждой следующей иконки
        });
    }, [links]);

    return (
        <div className="social-links-container">
            <div className="social-links-icons">
                {links.map((link, index) => (
                    <div
                        key={index}
                        className={`social-link-item ${visibleItems.includes(index) ? 'visible' : ''}`}
                        onClick={() => openExternalLink(link.url)}
                    >
                        <div className="social-link-icon">
                            <img src={link.icon} alt={link.title} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SocialLinks; 